import { trackKeyboardCopy } from '../lib/fpti';

export const addCopyListenerToCodeBlocks = () => {
  document.querySelectorAll('[data-testid="codeBlock"]').forEach((codeBlock) => {
    codeBlock.addEventListener('copy', () => {
      const copiedText = window.getSelection().toString().trim();
      let section = '';
      if (copiedText) {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          let parentDiv = range.commonAncestorContainer;
          while (parentDiv) {
            if (parentDiv.id) {
              section = parentDiv.id;
              break;
            }
            parentDiv = parentDiv.parentElement;
          }
        }
        trackKeyboardCopy(copiedText, section);
      }
    });
  });
};
